module.exports = __webpack_public_path__ + "img/room_n.f22ee0fb.png";